import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import update from 'immutability-helper'
import {
  SET_SUPPORTER_ONBOARDING_ACTIVE_STEP_INDEX,
  SET_NOTIFICATION,
  ClEAR_NOTIFICATION,
  SET_BACKDROP_LOADING
} from 'actions/status'
import { SIGN_UP } from 'actions/auth'

const setNotification = (state, { message, notificationType, duration }) => (
  update(state, {
    notification: {
      notificationType: { $set: notificationType },
      message: { $set: message },
      duration: { $set: duration }
    }
  })
)

const clearNotification = (state, action) => (
  update(state, { notification: { $set: {} } })
)

const updateSupporterOnboardingActiveStepIndex = (state, action) => (
  { ...state, supporterOnboardingActiveStepIndex: action.activeStep }
)

const setSupporterOnboardingActiveStepIndex = (state) => (
  { ...state, supporterOnboardingActiveStepIndex: 0 }
)

const setBackdropLoading = (state, { backdropLoading }) => (
  { ...state, backdropLoading: backdropLoading }
)

const handlers = {
  [`${SIGN_UP}_FULFILLED`]: setSupporterOnboardingActiveStepIndex,
  [SET_NOTIFICATION]: setNotification,
  [ClEAR_NOTIFICATION]: clearNotification,
  [SET_SUPPORTER_ONBOARDING_ACTIVE_STEP_INDEX]: updateSupporterOnboardingActiveStepIndex,
  [SET_BACKDROP_LOADING]: setBackdropLoading
}

const initialState = {
  supporterOnboardingActiveStepIndex: 0,
  notification: {},
  backdropLoading: false
}

const statusReducer = (state = initialState, action) => {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}

const statusPersistConfig = {
  key: 'status',
  whitelist: ['supporterOnboardingActiveStepIndex'],
  storage,
  timeout: null
}

export default persistReducer(statusPersistConfig, statusReducer)
